import { render } from "./ProsesSekilas.vue?vue&type=template&id=59297354"
import script from "./ProsesSekilas.vue?vue&type=script&lang=js"
export * from "./ProsesSekilas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__